import Vue from "vue";
import Router from "vue-router";
import Top from "../yukinkodaisenpu/src/components/HomePage.vue";
import Story from "../yukinkodaisenpu/src/components/StoryPage.vue";
import Product from "../yukinkodaisenpu/src/components/ProductPage.vue";
import Movie from "../yukinkodaisenpu/src/components/MoviePage.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "top",
      component: Top,
    },
    {
      path: "/story",
      name: "story",
      component: Story,
    },
    {
      path: "/product",
      name: "product",
      component: Product,
    },
    {
      path: "/movie",
      name: "movie",
      component: Movie,
    },
  ],
});
